import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import WS from 'store/common/ws';
import { selectLang } from 'store/measurements/selectors';
import RecaptchaProvider from 'components/ReCaptchaProvider/ReCaptchaProvider';
import { VERSION } from 'const';
// import SentryInit, { reactErrorHandlers } from 'sentry';
import routes from './router';
import 'i18n';
import './index.scss';
// if (NODE_ENV === 'production' && globalThis.location.hostname === 'geniemap.net') SentryInit();
// SentryInit();
dayjs.extend(utc);
const ToastContainerWrapper = () => {
    const isRtl = selectLang() === 'ar';
    return (React.createElement(ToastContainer, { position: isRtl ? 'bottom-right' : 'bottom-left', rtl: isRtl, style: { direction: 'ltr' }, autoClose: false, hideProgressBar: false, limit: 3, pauseOnFocusLoss: true, pauseOnHover: true }));
};
new WS();
console.log(VERSION);
/* if ('serviceWorker' in navigator && globalThis.location.hostname !== 'geniemap.net') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => console.log('SW registered:', reg)) // eslint-disable-line
      .catch((err) => console.error('SW registration failed:', err)); // eslint-disable-line
  });
} */
createRoot(document.getElementById('root')).render(React.createElement(React.Fragment, null,
    React.createElement(BrowserRouter, null,
        React.createElement(Routes, null, routes.map(({ path, element: Element, external }) => (React.createElement(Route, { key: path, path: path, element: (React.createElement(RecaptchaProvider, { external: external },
                React.createElement(Element, null))) }))))),
    React.createElement(ToastContainerWrapper, null)));
